import { useKey } from 'react-use';

const useCodeEditorShortcuts = ({
  active,
  canRun,
  canSubmit,
  disableExecution,
  focus,
  language,
  onRun,
  onSubmit,
  onSubmitShortcut,
}: any) => {
  return useKey(
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'true' is not assignable to param... Remove this comment to see the full error message
    true,
    (event) => {
      const shouldIgnoreKeyPress =
        (!canSubmit && !canRun) || !active || disableExecution;
      if (shouldIgnoreKeyPress) {
        return false;
      }

      const key = String.fromCharCode(event.keyCode);
      const ctrlKey = event.ctrlKey && !event.altKey;
      const ctrlOrMetaKey = ctrlKey || event.metaKey;
      const ENTER_KEY = 13;

      if (ctrlKey && key === '1') {
        focus();
        event.preventDefault();
      }

      if (ctrlOrMetaKey && event.keyCode === ENTER_KEY) {
        event.preventDefault();
        onSubmitShortcut();
        if ((event.shiftKey && canSubmit) || !canRun) {
          onSubmit();
        } else {
          onRun({ didUseKeyboardShortcut: true });
        }
      }
      return false;
    },
    { event: 'keydown' },
    [onRun, onSubmit, onSubmitShortcut, canSubmit, canRun, language, active],
  );
};

export default useCodeEditorShortcuts;
